const FirebaseConfig = {
  apiKey: "AIzaSyDLTJdU3FQ_71iI63QVlmAylS6mQ46cVXM",
  authDomain: "tunimobile-21bd2.firebaseapp.com",
  projectId: "tunimobile-21bd2",
  storageBucket: "tunimobile-21bd2.firebasestorage.app",
  messagingSenderId: "357037406511",
  appId: "1:357037406511:web:8da9f515377c58a5f3c9da",
  measurementId: "G-XFS6BG8Z8F"
};

// Public key of the Web Push certificate (Firebase console > Project settings > Cloud Messaging).
// Push notifications stay disabled while it is empty.
export const FCM_VAPID_KEY = "BGbrlZ-ecF9oJ-uyVJ3tIo9QVN0DgKTvYzOlAOfiEqBm60tKq5zpxFJnpeJ-TvdpqhMZlO_AGf9q0N4NNB06dBI";

export default FirebaseConfig

